
import {
    DATAWIN_SET_DATA_MODEL_ITEM,
    DATAWIN_SET_FETCH_ATTRIBUTES,
    DATAWIN_SET_FETCH_ATTRIBUTE_VISIBILITY,
    DATAWIN_SET_FETCH_GEOM,
    DATAWIN_SET_FETCH_PANEL_VISIBILITY,
    DATAWIN_SET_OBJECT,
    DATAWIN_SET_OBJECT_LIST,
    DATAWIN_UPDATE_ATTRIBUTE_IN_OBJECT_LIST
} from '../sagas/datawin';

const initialState = {
    dataModelItemId: null,
    fetchAttributes: {},
    fetchAttributeVisibility: {},
    fetchGeom: {},
    fetchPanelVisibility: false,
    objectKey: null,
    objectList: {},
};

export function calculateObjectKey(object) {
    return (object)
        ? `${object.layerId}_${object.attributes.gid}`
        : null;
}

export function getDataModelItemId(state) {
    return state.dataModelItemId;
}

export function getFetchAttributes(state, dataModelItemId) {
    return state.fetchAttributes[dataModelItemId] || {};
}

export function getFetchAttributeVisibility(state, dataModelItemId) {
    return state.fetchAttributeVisibility[dataModelItemId];
}

export function getFetchGeom(state, dataModelItemId) {
    return state.fetchGeom[dataModelItemId];
}

export function getFetchPanelVisibility(state) {
    return state.fetchPanelVisibility;
}

export function getObject(state) {
    return (state.objectList[state.dataModelItemId] || []).reduce((previous, current) => {
        return (current._key === state.objectKey)
            ? current
            : previous;
    }, null);
}

export function getObjectList(state, dataModelItemId) {
    return state.objectList[dataModelItemId];
}

function setDataModelItem(state, action) {
    return {
        ...state,
        dataModelItemId: action.id,
        objectKey: null
    };
}

function setFetchAttributes(state, action) {
    return {
        ...state,
        dataModelItemId: action.id,
        fetchAttributes: {
            ...state.fetchAttributes,
            [action.id]: action.attributes
        }
    };
}

function setFetchAttributeVisibility(state, action) {
    return {
        ...state,
        fetchAttributeVisibility: {
            ...state.fetchAttributeVisibility,
            [action.id]: action.attributes
        }
    };
}

function setFetchGeom(state, action) {
    return {
        ...state,
        fetchGeom: {
            ...state.fetchGeom,
            [action.id]: action.geom
        }
    };
}

function setFetchPanelVisibility(state, action) {
    return {
        ...state,
        fetchPanelVisibility: action.visible
    };
}

function setObject(state, action) {
    return {
        ...state,
        objectKey: calculateObjectKey(action.object)
    };
}

function calculateObjectList(previousObjectList, nextObjectList, mode) {
    const previousGids = (previousObjectList || []).map(item => item.attributes.gid);
    const nextGids = (nextObjectList || []).map(item => item.attributes.gid);

    switch (mode) {
        case 'ADD':
            return [
                ...previousObjectList,
                ...nextObjectList.map(item => {
                    return {
                        ...item,
                        _key: calculateObjectKey(item)
                    };
                }).filter(item => {
                    return (previousGids.indexOf(item.attributes.gid) === -1);
                })
            ];
        case 'FILTER':
            return [
                ...previousObjectList.filter(item => {
                    return (nextGids.indexOf(item.attributes.gid) !== -1);
                })
            ];
        case 'REMOVE':
            return [
                ...previousObjectList.filter(item => {
                    return (nextGids.indexOf(item.attributes.gid) === -1);
                })
            ];
        case 'SET':
            return nextObjectList.map(item => {
                return {
                    ...item,
                    _key: calculateObjectKey(item)
                };
            });
        default:
            log.warn(`unknown mode for setObjectList "${mode}"`);
            return previousObjectList;
    }
}

function setObjectList(state, action) {
    return {
        ...state,
        dataModelItemId: action.id,
        objectList: {
            ...state.objectList,
            [action.id]: calculateObjectList(
                state.objectList[action.id], action.objectList, action.mode
            )
        }
    };
}

function updateAttributeInObjectList(state, action) {
    let updatedObjects = getObjectList(state, action.dataModelItemId).map(item => {
        return (action.gids.indexOf(item.attributes.gid) !== -1)
            ? {
                ...item,
                attributes: {
                    ...item.attributes,
                    [action.attribute]: action.value
                }
            }
            : item;
    });

    return {
        ...state,
        objectList: {
            ...state.objectList,
            [action.dataModelItemId]: updatedObjects
        }
    };
}

function datawin(state = initialState, action) {
    switch (action.type) {

        case DATAWIN_SET_DATA_MODEL_ITEM:
            return setDataModelItem(state, action);

        case DATAWIN_SET_FETCH_ATTRIBUTES:
            return setFetchAttributes(state, action);

        case DATAWIN_SET_FETCH_ATTRIBUTE_VISIBILITY:
            return setFetchAttributeVisibility(state, action);

        case DATAWIN_SET_FETCH_GEOM:
            return setFetchGeom(state, action);

        case DATAWIN_SET_FETCH_PANEL_VISIBILITY:
            return setFetchPanelVisibility(state, action);

        case DATAWIN_SET_OBJECT:
            return setObject(state, action);

        case DATAWIN_SET_OBJECT_LIST:
            return setObjectList(state, action);

        case DATAWIN_UPDATE_ATTRIBUTE_IN_OBJECT_LIST:
            return updateAttributeInObjectList(state, action);

        default:
            return state;
    }
}

export default datawin;
